import React from 'react';
import { PublicFooter } from '/imports/ui/PublicFooter';
import { SignedOutPageStyled } from '/imports/ui/SignedOutPage';
import { Logo } from '/imports/ui/Logo';
import { privacyPolicyHtml } from '/imports/ui/privacyPolicy';

const privacyPolicyPageClasses = [
  '[&_.wrapper]:w-[55rem]! [&_.wrapper]:max-w-[90%]!',
  '[&_.logo_img]:mt-8',
].join(' ');

export const PrivacyPolicyPageStyled = (props: React.ComponentProps<typeof SignedOutPageStyled>) => (
  <SignedOutPageStyled
    {...props}
    className={`${privacyPolicyPageClasses}${props.className ? ` ${props.className}` : ''}`}
  />
);

export const PrivacyPolicyPage = () => {
  return (
    <PrivacyPolicyPageStyled className="page">
      <div className="wrapper">
        <div><Logo size={3} /></div>
        <div dangerouslySetInnerHTML={{__html: privacyPolicyHtml}} />
      </div>
      <PublicFooter />
    </PrivacyPolicyPageStyled>
  );
};
